import { Icon } from '@design';
import { DropdownMenuItemProps } from '@radix-ui/react-dropdown-menu';
import * as Radix from '@radix-ui/react-dropdown-menu';
import React, { ReactNode } from 'react';

import type { FilterProps } from './Filter';
import styles from './Filter.module.scss';

export interface FilterFooterActionsProps
  extends Pick<FilterProps, 'filter' | 'onCustomRangeClick' | 'labels'> {
  onRemove: DropdownMenuItemProps['onClick'];
  isMultiUseSingleFilter: boolean;
}

export const FilterFooterActions = ({
  filter,
  labels,
  isMultiUseSingleFilter,
  onCustomRangeClick,
  onRemove,
}: FilterFooterActionsProps) => {
  const showRemove = !filter.locked || isMultiUseSingleFilter;
  const showCustomRange = !!filter.config.custom;

  const renderItem = ({
    onClick,
    label,
    id,
  }: {
    onClick: DropdownMenuItemProps['onClick'];
    label: ReactNode;
    id: string;
  }) => {
    return (
      <>
        <div className={styles.separator} />
        <Radix.Item className={styles.item} data-testid={id} onClick={onClick}>
          <span
            className={styles.menuItemLeftIndicator}
            data-menu-item-indicator
          />
          <div className={styles.itemText} data-item-text>
            {label}
          </div>
        </Radix.Item>
      </>
    );
  };

  const removeNode =
    showRemove &&
    renderItem({
      id: 'remove',
      onClick: onRemove,
      label: (
        <p className={styles.removeLabel}>
          <Icon iconName="Trash" size={16} />
          <span>{labels.remove}</span>
        </p>
      ),
    });

  const customRangeNode =
    showCustomRange &&
    renderItem({
      id: 'custom-range',
      onClick: onCustomRangeClick,
      label: (
        <p className={styles.customLabel}>
          <Icon iconName="Settings" size={16} />
          <span>{labels.setCustomRange}</span>
        </p>
      ),
    });

  return (
    <>
      {customRangeNode}
      {removeNode}
    </>
  );
};
